import {
  IconMessage2,
  IconUser,
  IconTag,
  IconClock,
  IconMail,
  IconArchive,
  IconTrash,
  IconBold,
  IconItalic,
  IconLink,
  IconList,
  IconPaperclip,
  IconMoodSmile,
  IconSend,
} from "@tabler/icons-react";
import styles from "./TalentMessages.module.css";
import ConversationBubbles from "./ConversationBubbles";

export default function ConversationDetail({
  thread,
  replyText,
  onReplyChange,
  onSend,
  onMarkUnread,
  onArchive,
  onDelete,
  readOnly,
  hideActions,
}) {
  if (!thread) {
    return (
      <div className={styles.msgDetail}>
        <div className={styles.detailEmpty}>
          <div className={styles.detailEmptyIcon}>
            <IconMessage2 size={32} />
          </div>
          <h3>Select a conversation</h3>
          <p>Choose a thread from the list to read and reply to messages.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.msgDetail}>
      <div className={styles.detailHeader}>
        <div className={styles.detailHeaderLeft}>
          <div className={styles.detailSubject}>{thread.subject}</div>
          <div className={styles.detailMeta}>
            <span className={styles.detailMetaChip}>
              <IconUser size={14} /> {thread.sender} ({thread.email})
            </span>
            <span className={styles.detailMetaChip}>
              <IconTag size={14} /> {thread.type}
            </span>
            <span className={styles.detailMetaChip}>
              <IconClock size={14} /> {thread.date}
            </span>
          </div>
        </div>
        {!readOnly && !hideActions && (
          <div className={styles.detailHeaderActions}>
            <button
              className={styles.actionBtn}
              title="Mark as unread"
              onClick={onMarkUnread}
            >
              <IconMail size={17} />
            </button>
            <button
              className={styles.actionBtn}
              title="Archive"
              onClick={onArchive}
            >
              <IconArchive size={17} />
            </button>
            <button
              className={`${styles.actionBtn} ${styles.actionBtnDanger}`}
              title="Delete"
              onClick={onDelete}
            >
              <IconTrash size={17} />
            </button>
          </div>
        )}
      </div>

      <ConversationBubbles messages={thread.messages} />

      {readOnly ? (
        <div className={styles.replyBox}>
          <p style={{ margin: 0, fontSize: 13, color: "var(--muted, #6b7280)" }}>
            Replies from the support team appear here. To add to this request, raise it from the Support page.
          </p>
        </div>
      ) : (
        <div className={styles.replyBox}>
          <div className={styles.replyToolbar}>
            <button className={styles.replyFormatBtn} title="Bold">
              <IconBold size={14} />
            </button>
            <button className={styles.replyFormatBtn} title="Italic">
              <IconItalic size={14} />
            </button>
            <button className={styles.replyFormatBtn} title="Link">
              <IconLink size={14} />
            </button>
            <div className={styles.replyFormatSep} />
            <button className={styles.replyFormatBtn} title="Bullet list">
              <IconList size={14} />
            </button>
          </div>
          <textarea
            className={styles.replyTextarea}
            placeholder="Write your reply…"
            rows={3}
            value={replyText}
            onChange={(e) => onReplyChange(e.target.value)}
          />
          <div className={styles.replyFooter}>
            <div className={styles.replyFooterLeft}>
              <button className={styles.attachBtn} title="Attach file">
                <IconPaperclip size={16} />
              </button>
              <button className={styles.attachBtn} title="Emoji">
                <IconMoodSmile size={16} />
              </button>
            </div>
            <button className={styles.btnSend} onClick={onSend}>
              <IconSend size={15} /> Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
